var css = require.context("stylesheets")
css.keys().forEach(css)

var img = require.context("images")
img.keys().forEach(img)

// var js = require.context("javascripts")
// js.keys().forEach(js)

var componentRequireContext = require.context("components", true)
var ReactRailsUJS = require("react_ujs")
ReactRailsUJS.useContext(componentRequireContext)

require('jquery-ui-bundle')
require('jquery.cookie')

$( document ).ready(function() {
  $('.mobile_navigation').bind('touchmove', function(e){e.preventDefault()})

  $('.search_link').on('click', function(e){
    e.preventDefault();
    $('.search_holder').fadeToggle('slow');
    if($(this).html() == 'X') {
      $(this).html($(this).attr('data-search-img'))
    } else {
      $(this).css('font-size', '18px')
      $(this).html('X')
    }
  })

  function scrollToAnchor(elem){
    $('html,body').animate({scrollTop: $(elem).offset().top},'slow');
  }

  $(".jumper a").on('click', function(e){
    e.preventDefault();
    scrollToAnchor($(this).attr('href'));
  })

  $('.cookies button').click(function(e){
    $.cookie('hdd_cookie_consented', 'true', { path: '/', expires: 365 });
    $('.cookies').fadeOut("slow");
  });

});



// WEBPACK FOOTER //
// app/frontend/packs/application.js